<template>
  <div class="page-shell">
    <v-list subheader two-line>
      <v-card class="page-toolbar" flat>
        <b-row>
          <b-col cols="3">
            <AutoBusca
              id="cliente"
              item_id="id"
              item_text="nome"
              item_campos="cli.id as id, cli.id|| ' - ' ||cli.nome || ' - ' || cli.cnpj || ' ('||TRIM(cid.nome)||'/'||cid.uf||')' as nome, cli.cnpj as cnpj"
              item_busca="cli.id|| '-' || TRIM(UPPER(cli.nome))|| '-' || TRIM(UPPER(cli.cnpj)) "
              item_left="LEFT JOIN cidade cid ON cid.codcid=cli.codcid"
              tabela="cliente cli"
              :value="cliente"
              @getID="getID"
              :label="'Digite o cliente'"
              :rdark="true"
            />
          </b-col>
          <b-col cols="3">
            <v-select
              v-model="modulo"
              :items="Enum.modulos"
              dark
              outlined
              label="Módulo"
              hide-details="auto"
              item-text="text"
              item-value="val"
              no-data-text="Nenhuma Informação disponível"
            ></v-select>
          </b-col>
          <b-col cols="2">
            <v-select
              v-model="status"
              :items="Enum.status"
              dark
              outlined
              label="Status"
              hide-details="auto"
              item-text="text"
              item-value="val"
              no-data-text="Nenhuma Informação disponível"
            ></v-select>
          </b-col>
          <b-col cols="2">
            <v-text-field
              label="Termina em"
              placeholder="Não informado"
              outlined
              dark
              hide-details="auto"
              v-model="dataf"
              v-mask="['##/##/####']"
            ></v-text-field>
          </b-col>

          <b-col cols="2">
            <v-btn block x-large @click="ProcessarBloqueio">
              <v-icon>mdi-check-circle-outline</v-icon>&nbsp; Processar
            </v-btn>
          </b-col>
        </b-row>
      </v-card></v-list>
    <b-row>
      <b-col cols="8">
        <div class="bloqueios-quick-filter">
          <div class="bloqueios-quick-filter__copy">
            <strong>Filtros rapidos</strong>
            <span>Filtre a listagem por status 100 ou 999.</span>
          </div>
          <div class="bloqueios-quick-filter__chips">
            <v-chip
              v-for="filtro in filtrosRapidosStatus"
              :key="filtro.val || 'todos'"
              small
              label
              :input-value="filtroStatusRapido === filtro.val"
              class="bloqueios-quick-filter__chip"
              @click="selecionaFiltroRapido(filtro.val)"
            >
              {{ filtro.text }} ({{ filtro.total }})
            </v-chip>
          </div>
        </div>
      </b-col>
      <b-col cols="4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </b-col>
    </b-row>
    <v-data-table
      :headers="headers"
      :items="bloqueadosFiltrados"
      class="elevation-1"
      :search="search"
      :disable-pagination="true"
      no-data-text="Nenhum bloqueio encontrado para o filtro selecionado"
    >
      <!-- <template v-slot:item.status="{ item }">
                  
                  <b-row>
                    <b-col cols="7">
<v-select
              v-model="item.status"
              :items="Enum.status"
              
              label="Status"
              hide-details="auto"
              item-text="text"
              item-value="val"
              no-data-text="Nenhuma Informação disponível"
            ></v-select>
                    </b-col>
                    <b-col cols="2">
                         <v-btn icon @click="EditBloqueio(item)">
              <v-icon>mdi-check-circle-outline</v-icon>
            </v-btn>
                    </b-col>
                  </b-row>
                    
                </template> -->
    </v-data-table>
  </div>
</template>
<script>
import Vue from "vue";
import Gencli from "../domain/Gencli";
import _Enum from "../obj/Enum";
import AutoBusca from "../components/AutoBusca.vue";
export default {
  components: {
    AutoBusca,
  },
  data: () => ({
    Enum: _Enum,
    lst_bloqueados: [],
    search: "",
    headers: [
      {
        text: "CNPJ",
        align: "start",
        sortable: true,
        value: "cgc",
      },
      {
        text: "Empresa",
        align: "start",
        sortable: true,
        value: "empresa",
      },
      {
        text: "Módulo",
        align: "start",
        sortable: true,
        value: "modulo",
      },
      {
        text: "Status",
        align: "start",
        sortable: true,
        value: "status",
      },
      {
        text: "Data Final",
        align: "start",
        sortable: true,
        value: "dataf",
      },
      {
        text: "Versão",
        align: "start",
        sortable: true,
        value: "puversao",
      },
    ],
    status: "",
    filtroStatusRapido: "",
    modulo: "",
    cliente: "",
    cnpj: "",
    dataf: "",
    empresa: "",
  }),
  computed: {
    filtrosRapidosStatus() {
      return [
        {
          text: "Todos",
          val: "",
          total: this.lst_bloqueados.length,
        },
        {
          text: "Status 100",
          val: "100",
          total: this.totalPorStatus("100"),
        },
        {
          text: "Status 999",
          val: "999",
          total: this.totalPorStatus("999"),
        },
      ];
    },
    bloqueadosFiltrados() {
      if (!this.filtroStatusRapido) {
        return this.lst_bloqueados;
      }

      return this.lst_bloqueados.filter(
        (item) => this.normalizaStatus(item.status) === this.filtroStatusRapido
      );
    },
  },

  mounted() {
    this.carregaGenCli();
  },
  methods: {
    normalizaStatus(status) {
      const statusTexto = String(status || "").trim();
      const statusEncontrado = statusTexto.match(/\d+/);

      return statusEncontrado ? statusEncontrado[0] : statusTexto;
    },
    totalPorStatus(status) {
      return this.lst_bloqueados.filter(
        (item) => this.normalizaStatus(item.status) === status
      ).length;
    },
    selecionaFiltroRapido(status) {
      this.filtroStatusRapido = status;
    },
    carregaGenCli() {
      Vue.Loading("", "", this);
      this.service = new Gencli(this.$resource);
      this.service.get().then(
        function (tmp) {
          this.lst_bloqueados = tmp;
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    getID(val) {
      if (val.id == "cliente") {
        console.log(val.dados);
        this.cliente = val.value;
        this.cnpj = val.dados.cnpj;
        this.empresa = val.dados.empresa;
      }
    },
    ProcessarBloqueio() {
      var vm = this;
      // vm, title, content, callSim, callNao
      if (this.cliente == "") {
        Vue.Mensagem(vm, "Cliente", "Preencha o cliente por favor");
        return;
      }
      if (this.status == "") {
        Vue.Mensagem(vm, "Status", "Defina um status para o processamento");
        return;
      }

      Vue.Pergunta(
        vm,
        "Confirmar Processo",
        "Deseja prosseguir com a operação?",
        function () {
          Vue.Loading("", "", vm);
          vm.service = new Gencli(vm.$resource);
          vm.service
            .update({
              id: "",
              cgc: vm.cnpj,
              status: vm.status,
              dataf: vm.dataf,
              empresa: vm.empresa,
              modulo: vm.modulo,
            })
            .then(
              function (tmp) {
                //this.lst_bloqueados = tmp;
                console.log(tmp);
                Vue.CloseLoading(vm);
                vm.carregaGenCli();
              },
              (err) => {
                Vue.CloseLoading(vm);
                console.log(err);
              }
            );
        },
        null
      );
    },
  },
};
</script>
<style>
.bloqueios-quick-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 56px;
}

.bloqueios-quick-filter__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.bloqueios-quick-filter__copy strong {
  color: #0f172a;
  font-size: 0.98rem;
}

.bloqueios-quick-filter__copy span {
  color: #64748b;
  font-size: 0.84rem;
}

.bloqueios-quick-filter__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bloqueios-quick-filter__chip {
  border: 1px solid rgba(15, 76, 92, 0.14);
}

.bloqueios-quick-filter__chip.v-chip--active,
.bloqueios-quick-filter__chip.v-chip--input-value {
  background: rgba(15, 76, 92, 0.12) !important;
  color: #0f4c5c !important;
}

@media (max-width: 991px) {
  .bloqueios-quick-filter {
    justify-content: flex-start;
  }
}
</style>
